import { h } from 'preact'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDollarSign } from '@fortawesome/free-solid-svg-icons'

import { fuzzyPrice } from '../lib/utils'

const PriceRating = ({ price }) => {
  const priceRating = fuzzyPrice(price)

  const icons = []
  for (let i = 0; i < 4; i++) {
    const className = priceRating < (i + 1) ? '' : 'text-primary'
    icons.push((<FontAwesomeIcon icon={faDollarSign} className={className} />))
  }

  return (
    <span class='price-rating'>
      {icons}
    </span>
  )
}

export default PriceRating
